import(/* webpackMode: "eager", webpackExports: ["PlayerDetailsStatsPage"] */ "/app/apps/team-leagues/src/components/pages/PlayerDetailsPages/PlayerDetailsStatsPage.tsx");
